document.addEventListener('DOMContentLoaded', function () {
  const visibleParagraphs = 2;
  const descriptions = document.querySelectorAll('.collection-description');

  descriptions.forEach(function (description) {
    const children = Array.from(description.children);

    if (children.length <= visibleParagraphs) return;

    const extraContent = document.createElement('div');
    extraContent.className = 'collection-description-extra';
    extraContent.hidden = true;

    children.slice(visibleParagraphs).forEach(function (child) {
      extraContent.appendChild(child);
    });

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'collection-read-more-button';
    button.textContent = 'Read More';

    description.appendChild(button);
    description.appendChild(extraContent);

    button.addEventListener('click', function () {
      const isOpening = extraContent.hidden;

      extraContent.hidden = !isOpening;
      description.classList.toggle('is-expanded', isOpening);
      button.classList.toggle('is-floating', isOpening);
      button.textContent = isOpening ? 'Read Less' : 'Read More';

      if (isOpening) {
        document.body.appendChild(button);
      } else {
        description.insertBefore(button, extraContent);
        description.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});